export const JOBS_PAGES = {
  createJob: 'create-job',
  jobDetailsPage: 'job-details-page',
};

export const JOBS_MODALS = {
  createVacancy: 'createVacancy',
  deleteJob: 'deleteJob',
  setJobToEmployee: 'setJobToEmployee',
};
